import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody
} from '@emorg-prd/react-standard';

export function ProgressTabNavigator(props) {
  const {
    onNavigateBackward,
    onNavigateForward,
  } = props;
  const isNewLocation = window.location.pathname.toLowerCase().includes('newlocation');
  const [isDialogPopupVisible, setDialogPopupVisible] = useState(false);

  return (
    <div style={{ display: 'flex' }}>
      <Button
        variant='secondary'
        style={{ marginRight: '10px' }}
        onClick={() => setDialogPopupVisible(true)}
      >
        Cancel
      </Button>
      <Modal
        show={isDialogPopupVisible}
        onHide={() => setDialogPopupVisible(false)}
      >
        <ModalHeader>
          <h3>Keep in mind</h3>
        </ModalHeader>
        <ModalBody>
          {
            isNewLocation ? (
              <div>You'll return to the UDM homepage and lose any unsaved changes.</div>
            ) : (
              <div>You'll return to the location search page and lose any unsaved changes.</div>
            )
          }
          <div>Close this popup to continue working on this Location.</div>
          <Button
            className='small-margin'
            variant='secondary'
            style={{ marginTop: '20px', marginRight: '10px'}}
            onClick={() => setDialogPopupVisible(false)}
          >
            Close
          </Button>
          <a href={isNewLocation ? '/' : '/searchLocation'}>
            <Button
              className='small-margin'
              variant='primary'
              style={{ marginTop: '20px' }}
              onClick={() => setDialogPopupVisible(false)}
            >
              Return
            </Button>
          </a>
        </ModalBody>
      </Modal>
      {
        onNavigateBackward &&
        <Button
          className='small-margin'
          variant='secondary'
          style={{ marginRight: '10px' }}
          onClick={onNavigateBackward}
        >
          Back
        </Button>
      }
      {
        onNavigateForward &&
        <Button
          className='small-margin'
          variant='primary'
          onClick={onNavigateForward}
        >
          Next
        </Button>
      }
    </div>
  );
}

export default ProgressTabNavigator;
